import sonoma from '../../images/sonoma/sonoma.png';
import lightning from '../../images/sonoma/lightning.png';

export const SONOMA_CLUB_PROFILES = {

 "sonoma-valley-runners": {
  id: "sonoma-valley-runners",
  title: "Sonoma Valley Runners",
  images: [sonoma], // Add images manually
  isVerified: true,
  badges: ["free", "social", "morning"],
  whatToExpect: "Join a vibrant community that values both running and post-run celebrations. Expect friendly group runs through Sonoma, followed by ice baths, sauna sessions, and an ice-cold Old Caz Beer to top it off.",
  howToJoin: "Just show up at the meetup location and run with the group.",
  description:
    "Sonoma Valley Runners is more than a running club—it's a lifestyle. Combining social connections with miles on scenic routes, this group brings together runners who appreciate the journey just as much as the finish line. Post-run hangs are just as important as the workout itself!",
  subtitle: "Sonoma",
  whyWeLikeIt:
    "This isn’t just a run club—it’s a post-run party. Between the scenic routes, ice baths, and local craft beer, SVR has mastered the art of balancing sweat and socializing.",
  socialInfo: [
    "Post-run beer & ice baths",
    "Medium group size",
    "Casual & fun atmosphere",
    "All paces welcome"
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/sonomavalleyrunners?igsh=NGVhN2U2NjQ0Yg%3D%3D&utm_source=qr",
      platform: "instagram",
    },
    {
      name: "Website",
      url: "https://sonomavalleyrunners.com/",
      platform: "website",
    },
  ],
  meetPoint: {
    details: ["Sebastiani Vineyards & Winery"],
    link: {
      text: "Sebastiani Vineyards & Winery",
      url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13767.987283685!2d-122.44477836962302!3d38.28781455059225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085aeaae8b6e867%3A0x53d948f1bfa23c64!2sSebastiani%20Vineyards%20%26%20Winery!5e0!3m2!1sen!2sus!4v1739839837052!5m2!1sen!2sus", // Replace with actual link if available
    },
  },
  runDays: [
    {
      day: "Sunday",
      times: ["8:30 AM"],
      distance: "2.3 miles",
      location: "Sebastiani Vineyards & Winery",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3119.2653445899164!2d-122.41411900000001!3d38.573737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ada59b9184917%3A0x736d51e3cd971e97!2sSebastiani%20Vineyards%20and%20Winery!5e0!3m2!1sen!2sus!4v1739656745192!5m2!1sen!2sus"
    }
  ],
  joinLink: "",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/sonomavalleyrunners/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border-radius:px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:100%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px; border:0"> <a href="https://www.instagram.com/sonomavalleyrunners/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657"></path></g></g></g></svg></div></a></div></blockquote>`,
},

"lightning-run-club": {
  id: "lightning-run-club",
  title: "Lightning Run Club",
  images: [lightning], // Add images manually
  isVerified: true,
  badges: ["social", "free", "morning", "evening"],
  whatToExpect: "Lightning Run Club is all about progress, support, and community. Whether you're aiming to improve your pace, train for an event, or just enjoy the process of running, this club welcomes all paces and backgrounds. Runs are structured yet fun, creating a strong sense of camaraderie.",
  howToJoin: "Simply show up at any of their scheduled runs and introduce yourself to the group.",
  description:
    "Lightning Run Club is built on the idea that running is better together. Whether you're new to running or a seasoned athlete, this club offers a mix of track workouts and scenic Sunday runs, helping members find joy in the process while building strong friendships along the way.",
  subtitle: "Sonoma, CA",
  whyWeLikeIt:
    "Lightning Run Club blends structured training with an inclusive, social atmosphere. They mix track sessions with relaxed group runs, making it easy for all levels to get involved. The club fosters an environment where runners push each other while having fun.",
  socialInfo: [
    "All paces welcome",
    "Track workouts & long runs",
    "Supportive running community",
    "Focused on progress & fun"
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/lightningrunclub/",
      platform: "instagram",
    },
    {
      name: "Strava",
      url: "https://www.strava.com/clubs/LightningRunClub?share_sig=136097211725431427&fbclid=PAZXh0bgNhZW0CMTEAAaZ266npcTjw8EA8qJpWafuYDtRTjcq_3aSw5S8x7bQlY0WFstI_6Ex41q8_aem_cGzWWZEq7KzfpQqZQERAxA&_branch_match_id=1360429223595288087&_branch_referrer=H4sIAAAAAAAAAw",
      platform: "strava",
    },
  ],
  meetPoint: {
    details: ["Howarth Park for Sunday runs", "SSU Track for Tuesday workouts"],
    link: {
      text: "Howarth Park, Sonoma",
      url: "https://maps.app.goo.gl/xyz", // Replace with actual link if available
    },
  },
  runDays: [
    {
      day: "Tuesday",
      times: ["6:30 PM"],
      distance: "Track session",
      location: "SSU Track",
      googleMapLink: "", // Add if available
    },
    {
      day: "Sunday",
      times: ["7:30 AM"],
      distance: "3.6 miles",
      location: "Howarth Park",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30285.371598199195!2d-122.66857943096626!3d38.441895303874176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8084383b84375edb%3A0x60b635443f69b1b0!2sHowarth%20Park!5e0!3m2!1sen!2sus!4v1739841016533!5m2!1sen!2sus"
    }
  ],
  joinLink: "",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/lightningrunclub/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border-radius:px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:100%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px; border:0"> <a href="https://www.instagram.com/lightningrunclub/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657"></path></g></g></g></svg></div></a></div></blockquote>`,
}




};

